import { ReportResponse, ReturnedPiecesResponse, SalesByDayResponse, SalesReportResponse, } from '@aeris/contracts';
import { clientTimeZone, request } from "./client.js";
export const fetchReport = async (filter, signal) => {
    const params = new URLSearchParams({
        from: filter.from,
        to: filter.to,
        cut: String(filter.cut),
    });
    if (filter.branchId !== undefined && filter.branchId !== '') {
        params.set('branchId', filter.branchId);
    }
    if (filter.dimension !== undefined)
        params.set('dimension', filter.dimension);
    return ReportResponse.parse(await request(`/api/v1/reports/${filter.report}?${params.toString()}`, {
        signal,
    }));
};
export const fetchReturnedPieces = async (filter, signal) => {
    const params = new URLSearchParams({
        from: filter.from,
        to: filter.to,
        page: String(filter.page),
        pageSize: String(filter.pageSize),
    });
    if (filter.branchId !== undefined && filter.branchId !== '') {
        params.set('branchId', filter.branchId);
    }
    if (filter.reasonCode !== undefined) {
        params.set('reasonCode', filter.reasonCode);
    }
    if (filter.search !== undefined && filter.search !== '') {
        params.set('search', filter.search);
    }
    return ReturnedPiecesResponse.parse(await request(`/api/v1/reports/pecas-devolvidas?${params.toString()}`, {
        signal,
    }));
};
const salesParams = (filter) => {
    const params = new URLSearchParams({ from: filter.from, to: filter.to });
    if (filter.branchId !== undefined && filter.branchId !== '') {
        params.set('branchId', filter.branchId);
    }
    if (filter.customerId !== undefined && filter.customerId !== '') {
        params.set('customerId', filter.customerId);
    }
    params.set('timeZone', clientTimeZone());
    return params.toString();
};
export const fetchSalesReport = async (filter, signal) => SalesReportResponse.parse(await request(`/api/v1/reports/vendas?${salesParams(filter)}`, { signal }));
export const fetchSalesByDay = async (filter, signal) => SalesByDayResponse.parse(await request(`/api/v1/reports/vendas-por-dia?${salesParams(filter)}`, {
    signal,
}));
//# sourceMappingURL=reports.js.map